import {useCallback, useEffect, useState} from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { TextField } from "@mui/material";

// core components
import Button from "../CustomButtons/Button";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {useForumsCommentReportRequest, useForumsDeleteTopicRequest} from "../../request/api";
import {useCommentContext} from "../../contexts/comment";

const useStyles = makeStyles()(styles);

export default function ForumsReportModal(props) {
    const { classes, cx } = useStyles();
    const { commentId, reloadData } = props;
    const [reportCategory, setReportCategory] = useState("");
    const [reportSuccess, setReportSuccess] = useState(false);
    const [reportDetails, setReportDetails] = useState("");

    const reportCategories = [
      "Breaking the Rules",
      "Bullying",
      "False Info",
      "Hate Speech",
      "Off-Topic",
      "Rude or Offensive",
      "Safety Concerns",
      "Sharing Private Info",
      "Spam"
    ];

    const {
        isMutating: isReportingComment,
        trigger: reportComment,
        error: reportCommentError,
    } = useForumsCommentReportRequest(
      { commentId: commentId },
      undefined,
      {
          withCredentials: true,
      }
    );

    const handleReportCategory = useCallback(async (e) => {
        e.preventDefault();

        if (reportCategory === '') {
            return;
        }

        await reportComment({
            body: { report_reason: `${reportCategory} - ${reportDetails}` }
        })

        setReportSuccess(true);
        await reloadData();
    }, [reportDetails, reportCategory]);

    if (reportCategory === "") {
        return <>
            <div className={classes.reportModalContent}>
                <p className={classes.reportModalTitle}>Submit a report</p>
                <p className={classes.reportModalText}>
                    Thanks for looking out for yourself and the Success at School
                    community by reporting things that break the rules. Let us know
                    what&apos;s happening and we&apos;ll look into it.
                </p>
                <div className={classes.modalTagContainer}>
                    {reportCategories.map((category, index) => {
                        return (
                          <Button
                            className={classes.modalReportTag}
                            onClick={() => setReportCategory(category)}
                            key={index}
                          >
                              {category}
                          </Button>
                        );
                    })}
                </div>
            </div>
        </>;
    }

    return (
      <>
        {reportSuccess ?
            <>
            <div className={classes.reportModalContent}>
              <p className={classes.reportModalTitle}>Reported!</p>
              <p className={classes.reportModalText}>
                Thanks for doing your part. We will look into the matter as soon
                as possible.
              </p>
              <Button
                className={cx(
                  classes.darkButton +
                    " " +
                    classes.wideButton +
                    " " +
                    classes.reportModalSubmitButton
                )}
                onClick={props.onClose}
              >
                Done
              </Button>
            </div>
          </> : <>
            <form onSubmit={handleReportCategory} className={classes.reportModalContent}>
                <p className={classes.reportModalTitle}>Anything else you&apos;d like to add?</p>
                <p className={classes.reportModalText}>Got it. Would you like to add any more additional information that you think would be helpful for us?</p>
                <p className={classes.modalReportTagHeader}>{reportCategory}</p>
                <TextField placeholder="Add some more information..." className={classes.reportModalTextEditor} onChange={(e) => setReportDetails(e.target.value)} value={reportDetails} multiline rows={3} variant="outlined"></TextField>
                <Button className={cx(classes.darkButton + " " + classes.wideButton + " " + classes.reportModalSubmitButton)} type="submit">Submit</Button>
            </form>
        </>
        }
      </>
    );
}

